import { render } from "./AdminSysSupportTab.vue?vue&type=template&id=b81bee1e&ts=true"
import script from "./AdminSysSupportTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysSupportTab.vue?vue&type=script&lang=ts"

import "./AdminSysSupportTab.vue?vue&type=style&index=0&id=b81bee1e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__